import styled from '@emotion/styled'
import React from 'react'

export const StyledTableBody = styled.tbody``

export const StyledCell = styled.td`
  padding: 18px;
  text-align: left;
  color: #8b8a90;
  font-size: 0.75em;
  font-family: 'proxima-nova', sans-serif;
`

export const StyledRow = styled.tr`
  border-bottom: 1px solid #e9e9eb;
`

export const NoRegisterWrapper = styled.div`
  display: flex;
  justify-content: center;
  align-items: center;
  padding: 16px;
`
export const NoRegisterMessage = styled.p`
  color: #8b8a90;
  font-size: 0.75em;
  font-family: 'proxima-nova', sans-serif;
  font-weight: 700;
`
